import { render, staticRenderFns } from "./MindWithJoy.vue?vue&type=template&id=651aa7d2"
import script from "./MindWithJoy.vue?vue&type=script&lang=js"
export * from "./MindWithJoy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports